export const transformStringToLowercase = (value: any) =>
  value && typeof value === 'string' ? value.toLowerCase() : value;

export const transformStringToUppercase = (value: any) =>
  value && typeof value === 'string' ? value.toUpperCase() : value;
